import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { StoreExposeGroup } from '../interface';
export class ReadFranchiseStoreExternalReferenceDto {
}
__decorate([
    ApiProperty({ type: () => String, description: 'External Location ID', example: '6Y718PCAWAZBA' }),
    Expose({ groups: [StoreExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadFranchiseStoreExternalReferenceDto.prototype, "locationId", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'External Merchant ID', example: '35ADFP18W8DHT' }),
    Expose({ groups: [StoreExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadFranchiseStoreExternalReferenceDto.prototype, "merchantId", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'The name of the External Merchant overall business.' }),
    Expose({ groups: [StoreExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadFranchiseStoreExternalReferenceDto.prototype, "businessName", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'The country of the External Merchant, in the two-letter format of ISO 3166. Ex. "US".' }),
    Expose({ groups: [StoreExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadFranchiseStoreExternalReferenceDto.prototype, "country", void 0);
//# sourceMappingURL=ReadFranchiseStoreExternalReferenceDto.js.map